import Vue from 'vue'
import Vuex from 'vuex'
import tab from './tab.js'  //引入tab.js
Vue.use(Vuex) //进行全局的注入
//创建vues的实例
export default new Vuex.Store({
    modules:{
        tab   //注册tab并返回暴露
    }
})